<template>
<div class="list-step">
<ol class="list-step__list">
<li class="list-step__list-item" v-bind:class="{'list-step__list-item--current': index === 1}">
<span class="list-step__list-item-inner">STEP<em>1</em></span>
<!-- /.list-step__list-item --></li>
<li class="list-step__list-item" v-bind:class="{'list-step__list-item--current': index === 2}">
<span class="list-step__list-item-inner">STEP<em>2</em></span>
<!-- /.list-step__list-item --></li>
<li class="list-step__list-item" v-bind:class="{'list-step__list-item--current': index === 3}">
<span class="list-step__list-item-inner">STEP<em>3</em></span>
<!-- /.list-step__list-item --></li>
<li class="list-step__list-item" v-bind:class="{'list-step__list-item--current': index === 4}">
<span class="list-step__list-item-inner">試算結果</span>
<!-- /.list-step__list-item --></li>
<!-- /.list-step__list --></ol>
<!-- /.list-step --></div>
</template>

<script>
export default {
    data: function () {
        return {
            index: 1
        };
    },
    methods: {
        updateIndex: function (path) {
            path.match(/\/step(.)(|.+?)/g);

            this.$data.index = Number(RegExp.$1);
        }
    },
    watch: {
        $route: function (to) {
            this.updateIndex(to.path);
        }
    },
    created: function () {
        this.updateIndex(this.$route.path);
    }
};
</script>



// WEBPACK FOOTER //
// src/components/StepList.vue